import { StyleSheet } from 'react-native';

export const createStyles = (theme: 'light' | 'dark' = 'light') => {
  const colors = {
    light: {
      background: '#FFFFFF',
      cardBackground: '#FFFFFF',
      sectionBackground: '#F7F7F7',
      text: '#333333',
      subText: '#999999',
      border: '#E8E8E8',
      divider: '#F0F0F0',
    },
    dark: {
      background: '#1A1A1A',
      cardBackground: '#2A2A2A',
      sectionBackground: '#1A1A1A',
      text: '#FFFFFF',
      subText: '#999999',
      border: '#3A3A3A',
      divider: '#333333',
    },
  };

  const c = colors[theme];

  return StyleSheet.create({
    // 基础容器
    container: {
      backgroundColor: 'transparent',
    },
    // 卡片样式
    card: {
      backgroundColor: c.cardBackground,
      borderRadius: 12,
      overflow: 'hidden',
    },
    cardShadowSm: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.05,
      shadowRadius: 2,
      elevation: 1,
    },
    cardShadowMd: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.08,
      shadowRadius: 4,
      elevation: 3,
    },
    cardShadowLg: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.12,
      shadowRadius: 8,
      elevation: 6,
    },
    cardHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: c.divider,
    },
    cardHeaderContent: {
      flex: 1,
    },
    cardTitle: {
      fontSize: 16,
      fontWeight: '600',
      color: c.text,
    },
    cardSubtitle: {
      fontSize: 13,
      color: c.subText,
      marginTop: 2,
    },
    cardBody: {
      padding: 16,
    },
    cardFooter: {
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderTopWidth: StyleSheet.hairlineWidth,
      borderTopColor: c.divider,
    },
    cardCover: {
      width: '100%',
      resizeMode: 'cover',
    },
    cardCollapse: {
      marginLeft: 8,
    },
    // Section样式
    section: {
      backgroundColor: c.sectionBackground,
    },
    sectionHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 16,
      paddingVertical: 12,
    },
    sectionHeaderLeft: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    sectionIcon: {
      marginRight: 8,
    },
    sectionTitle: {
      fontSize: 15,
      fontWeight: '600',
      color: c.text,
    },
    sectionDivider: {
      height: StyleSheet.hairlineWidth,
      backgroundColor: c.divider,
      marginHorizontal: 16,
    },
    sectionContent: {
      paddingHorizontal: 16,
      paddingVertical: 12,
    },
    // Flex样式
    flex: {
      display: 'flex',
    },
    // Row/Col
    row: {
      flexDirection: 'row',
    },
    col: {
      flexDirection: 'column',
    },
    center: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    // Spacer
    spacer: {
      backgroundColor: 'transparent',
    },
    // Disabled
    disabled: {
      opacity: 0.5,
    },
    // Full width
    fullWidth: {
      width: '100%',
    },
  });
};

export default createStyles;
